// reducers.js
import { SET_COMPANY_INFO } from './actions';

const initialState = {
  info: process.env.NODE_ENV === 'development' ? {
    _id: '675f0e2054a3387145c3fdaf',
    logo: "https://booker-coach.s3.us-east-2.amazonaws.com/logo-calendia.png",
    subscription: "free",
    companyName: "devzona",
    companyWebsite: 'devzona.com',
    color: "#3b2287"
  } : {}
};

const companyInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANY_INFO:
      return {
        ...state,
        info: action.payload,
      };
    default:
      return state;
  }
};

export default companyInfoReducer;
